<template>
<div class="slices-outer bg-gray-700 relative">
    <div class="slices-inner relative z-20" :class="{'pb-24': lastSlice && lastSlice.name == 'basic_content', 'pt-24': firstSlice && firstSlice.name == 'basic_content'}">
        <component v-for="slice in slices" :is="slice.name" :data="slice.data"></component>
    </div>
</div>
</template>

<script>
import { computed } from 'vue';

import anchor_id from './Slices/AnchorId.vue';
import basic_content from './Slices/BasicContent.vue';
import bio from './Slices/Bio.vue';
import button_row from './Slices/ButtonRow.vue';
import category_feed from './Slices/CategoryFeed.vue';
import extra_space from './Slices/ExtraSpace.vue';
import full_width_photo from './Slices/FullWidthPhoto.vue';
import horizontal_separator from './Slices/HorizontalSeparator.vue';
import list_columns from './Slices/ListColumns.vue';
import location_banner from './Slices/LocationBanner.vue';
import person_grid from './Slices/PersonGrid.vue';
import styled_table from './Slices/StyledTable.vue';
import youtube_video from './Slices/YoutubeVideo.vue';

export default {

    props: {
        slices: {
            default: []
        }
    },

    setup(props) {
        const firstSlice = computed(() => {
            return props.slices.length
                ? props.slices[0]
                : null;
        });
        const lastSlice = computed(() => {
            return props.slices.length
                ? props.slices[props.slices.length - 1]
                : null;
        });
        return {
            firstSlice,
            lastSlice
        }
    },
    
    components: {
        anchor_id,
        basic_content,
        bio,
        button_row,
        category_feed,
        extra_space,
        full_width_photo,
        horizontal_separator,
        list_columns,
        location_banner,
        person_grid,
        styled_table,
        youtube_video
    }

}
</script>